<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title d-flex align-items-center justify-content-between">
          <span><i class="fas fa-file-invoice-dollar me-2"></i> {{ wizardTitle }}</span>
        </h4>
      </div>
      <div class="card-body">
        @if (submittedDate) {
          <div class="alert alert-success mb-3" role="alert">
            <i class="fas fa-check-circle me-2"></i>
            This {{ wizardTitle }} was submitted successfully on {{ submittedDate | date:'medium' }}.
            @if (formModel?.generatedDocument?.documentType?.documentTypeName) {
              The document can be found in Loan Docs under "{{ formModel.generatedDocument.documentType.documentTypeName }}".
            }
          </div>
        }

        <!-- Flow Type Selection -->
        @if (!flowTypeSelected) {
          <div class="flow-type-selection mb-4">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-3">Select Request Type</h5>
                <p class="text-muted mb-3">Please select the type of request you want to submit:</p>
                <div class="d-flex flex-column gap-2">
                  @for (option of flowTypeOptions; track $index) {
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flowType"
                        [id]="'flowType_' + option.value"
                        [value]="option.value"
                        [(ngModel)]="selectedFlowType">
                      <label class="form-check-label" [for]="'flowType_' + option.value">
                        {{ option.label }}
                      </label>
                    </div>
                  }
                </div>
                <button
                  type="button"
                  class="btn btn-primary mt-3"
                  (click)="onFlowTypeSelected()">
                  Continue
                </button>
              </div>
            </div>
          </div>
        }

        @if (flowTypeSelected) {
          <loda-stepper-v2 [activeStepIndex]="activeStepIndex" [steps]="transformedSteps"></loda-stepper-v2>

        <div class="wizard-content mt-4" [ngStyle]="{'min-height': '400px'}">
          @if (isLoadingData) {
            <div class="text-center py-5">
              <span class="spinner-border spinner-border-lg" role="status"></span>
              <p class="mt-2">Loading form data...</p>
            </div>
          }
          @if (!isLoadingData) {
            <div [hidden]="activeStepIndex !== 0">
              <corr-header #corrHeaderStep
                [brokerInformation]="formModel?.brokerInformation"
                [loanInformation]="formModel?.loanInformation"
                [correspondentOnly]="formModel?.correspondentOnly">
              </corr-header>
            </div>
            <div [hidden]="activeStepIndex !== 1">
              <icd-property-information #propertyWarehouseStep
                [propertyInformation]="formModel?.propertyInformation"
                [isIcdFlow]="isIcdFlow">
              </icd-property-information>
            </div>
            <div [hidden]="activeStepIndex !== 2">
                <origination-fees #originationFeesStep
                  [fees]="formModel?.fees"
                  [correspondentOnly]="formModel?.correspondentOnly">
                </origination-fees>
            </div>
            <div [hidden]="activeStepIndex !== 3">
              <services-can-shop #servicesCanShopStep
                [fees]="formModel?.fees"
                [correspondentOnly]="formModel?.correspondentOnly">
              </services-can-shop>
            </div>
            <div [hidden]="activeStepIndex !== 4">
              <services-cannot-shop #servicesCannotShopStep
                [fees]="formModel?.fees"
                [correspondentOnly]="formModel?.correspondentOnly">
              </services-cannot-shop>
            </div>
            <div [hidden]="activeStepIndex !== 5">
              <lender-credits-fees #lenderCreditsFeesStep
                [fees]="formModel?.fees"
                [correspondentOnly]="formModel?.correspondentOnly">
              </lender-credits-fees>
            </div>
            <div [hidden]="activeStepIndex !== 6">
              <contact-information #contactInformationStep
                [sellerRealEstateAgent]="formModel?.sellerRealEstateAgent"
                [titleInformation]="formModel?.titleInformation"
                [escrowInformation]="formModel?.escrowInformation"
                [settlementInformation]="formModel?.settlementInformation">
              </contact-information>
            </div>
            <div [hidden]="activeStepIndex !== 7">
              <review-submit #reviewSubmitStep [parentWizard]="this"></review-submit>
            </div>
          }
        </div>
        }

        @if (flowTypeSelected) {
          <div class="wizard-navigation d-flex justify-content-center mt-4">
            <button
              type="button"
              class="btn btn-primary me-2"
              [disabled]="atFirstStep || isStepRunning"
              (click)="navigateBackward()">
              <i class="fas fa-arrow-left me-1"></i> Back
            </button>
            @if (!atLastStep) {
              <button
                type="button"
                class="btn btn-primary me-2"
                [disabled]="isStepRunning || disableNextButton"
                (click)="navigateForward()">
                @if (isStepRunning) {
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                }
                {{ isStepRunning ? 'Please wait...' : nextButtonLabel }}
                @if (!isStepRunning) {
                  <i class="fas fa-arrow-right ms-1"></i>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
